// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"8eb9bac7","498":"6e1932d5","513":"039dd682"}[chunkId] + ".chunk.js";
};